/**
 * Utilities for handling embedded quiz authentication tokens
 */

/**
 * Check if a JWT token is expired
 */
export function isTokenExpired(token: string): boolean {
  try {
    // JWT format: header.payload.signature
    const parts = token.split(".")
    if (parts.length !== 3) return true

    // Decode the payload (base64url)
    const payload = JSON.parse(atob(parts[1]))

    // Check if exp claim exists and if it's expired
    if (!payload.exp) return false // No expiration claim

    // exp is in seconds, Date.now() is in milliseconds
    const expirationTime = payload.exp * 1000
    const now = Date.now()

    return now >= expirationTime
  } catch (error) {
    console.error("[TOKEN UTILS] Error checking token expiration:", error)
    return true // Assume expired if we can't decode
  }
}

/**
 * Check if the current localStorage token is expired
 * and clear it if it is
 */
export function clearExpiredToken(): boolean {
  const token = localStorage.getItem("access_token")
  if (!token) return false

  const expired = isTokenExpired(token)
  if (expired) {
    console.log("[TOKEN UTILS] Clearing expired token from localStorage")
    localStorage.removeItem("access_token")
    sessionStorage.removeItem("access_token")
    return true
  }

  return false
}

/**
 * Check if we're in an embedded context (iframe or embed routes)
 */
export function isEmbeddedContext(): boolean {
  const isInIframe = window.self !== window.top
  const isEmbedRoute = window.location.pathname.startsWith("/embed")
  return isInIframe || isEmbedRoute
}
